import { useGetProfile } from '@sunrise-ui/api-client';
import { useInitializeSession } from '@sunrise-ui/composites';
import { useAuthStore } from '@sunrise-ui/primitives';
import { useEffect } from 'react';

export function CommunityAuthController() {
  const { currentUserId, isAuthenticated, hasAcceptedTerms, setIsOnboarded } =
    useAuthStore();
  const { data: profile, isLoading: isLoadingProfile } =
    useGetProfile(currentUserId);

  useInitializeSession();

  useEffect(() => {
    if (isAuthenticated && !isLoadingProfile) {
      setIsOnboarded(
        Boolean(
          hasAcceptedTerms &&
            profile?.first_name &&
            profile?.last_name &&
            profile?.headline,
        ),
      );
    }
  }, [
    isLoadingProfile,
    isAuthenticated,
    profile,
    hasAcceptedTerms,
    setIsOnboarded,
  ]);

  return null;
}
